import React, { useState, useEffect, useRef } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { useDiasSeleccionados } from "./Helper/useDiasSeleccionados";
import { RSMiniCalendario } from "./RSMiniCalendario";
import { generarImagenRedes, confirmarImagenRedes } from "../../../Helpers/RedesWebhook";
import { descargarBase64 } from "../../../Helpers/DescargarArchivo";

export const RSAñadirModal = ({ open, onClose, onActualizar, eventoSeleccionado }) => {
    const today = new Date();
    const esEdicion = !!eventoSeleccionado;
    

    const [tipoPublicacion, setTipoPublicacion] = useState("");
    const [listadoTipos, setListadoTipos] = useState([]);
    const [cargandoTipos, setCargandoTipos] = useState(false);
    const [openTipos, setOpenTipos] = useState(false);
    const [openLineas, setOpenLineas] = useState(false);
    const lineasFijas = ["Campaña", "Drones", "Implementos", "Maquinaria ", "Rivulis", "Servicio", "Usados", "Producto_Aliado"];
    const [openFirmas, setOpenFirmas] = useState(false);
    const firmasFijas = ["Drones.png", "JohnDeere.png", "maquinaria_humaya.png", "rivulis.png", "FIRMA_JD_FESTIVIDADES.png", "FIRMA_VACANTE.png", "FIRMA_DJI_CURSO_DRONE.png"];
    const [linea, setLinea] = useState("");
    const [precioLista, setPrecioLista] = useState("");
    const [precioEspecial, setPrecioEspecial] = useState("");
    const [beneficios, setBeneficios] = useState("");
    const [vigencias, setVigencias] = useState("");
    const [restricciones, setRestricciones] = useState("");
    const [escenografia, setEscenografia] = useState("");
    const [imagen, setImagen] = useState("");
    const [imagenBase64, setImagenBase64] = useState("");
    const [archivoImagen, setArchivoImagen] = useState(null);
    const diasPub = useDiasSeleccionados();
    const [guardando, setGuardando] = useState(false);
    const fileInputRef = useRef(null);
    const tiposCargadosRef = useRef(false); // evita re-pedir el listado de tipos en cada apertura del modal
    const [hora, setHora] = useState("");
    const [redSocial, setRedSocial] = useState([]);
    const [firma, setFirma] = useState("");
    const toggleRedSocial = (red) => {
        setRedSocial(prev =>
            prev.includes(red)
                ? prev.filter(r => r !== red)
                : [...prev, red]
        );
    };

    const esCampaña = tipoPublicacion === "Campaña";
    const esPromocion = tipoPublicacion === "Promoción";
    const [cargar, setCargar] = useState(true);

    const [vista, setVista] = useState("formulario"); // "formulario" | "revision"
    const [generandoImagen, setGenerandoImagen] = useState(false);
    const [imagenGenerada, setImagenGenerada] = useState(null); // { base64, copy, folio, tipoPublicacion, fechaEnvio }
    const [folioBorrador, setFolioBorrador] = useState(null); // folio de la publicación nueva ya creada, pendiente de aprobar
    const editandoBorrador = !esEdicion && !!folioBorrador;

    useEffect(() => {
        if (tipoPublicacion === "Campaña") {
            setLinea("Campaña");

        }
    }, [tipoPublicacion]);

    useEffect(() => {
        if (!open) return;

        if (!tiposCargadosRef.current) {
            tiposCargadosRef.current = true;
            const opcionesFijas = ["Campaña", "Liquidación", "Promoción"];

            setCargandoTipos(true);
            request
                .get("Encabezado/Listado")
                .then((result) => {
                    const tiposAPI = (result ?? []).map(e => e.Tipo_Publicacion).filter(Boolean);
                    const tiposUnificados = [...new Set([...opcionesFijas, ...tiposAPI])];
                    setListadoTipos(tiposUnificados);
                })
                .catch(() => {
                    setListadoTipos(opcionesFijas);
                    tiposCargadosRef.current = false; // permite reintentar en la próxima apertura si falló
                })
                .finally(() => setCargandoTipos(false));
        }

        if (esEdicion) {

            setCargar(eventoSeleccionado.cargar === true || eventoSeleccionado.cargar === 1);
            setTipoPublicacion(eventoSeleccionado.tipo_Publicacion ?? "");
            setLinea(eventoSeleccionado.linea ?? "");
            setPrecioLista(eventoSeleccionado.precio_Lista ?? "");
            setPrecioEspecial(eventoSeleccionado.precio_Especial ?? "");
            setBeneficios(eventoSeleccionado.beneficios ?? "");
            setVigencias(eventoSeleccionado.vigencias ?? "");
            setRestricciones(eventoSeleccionado.restricciones ?? "");
            setEscenografia(eventoSeleccionado.escenografia ?? "");
            setImagen(eventoSeleccionado.imagen ?? "");
            setImagenBase64(eventoSeleccionado.imagenBase64 ?? "");
            setHora(eventoSeleccionado.hora ?? "");
            setRedSocial(
                eventoSeleccionado.red_Social
                    ? eventoSeleccionado.red_Social.split(",").map(x => x.trim())
                    : []
            );

            setFirma(eventoSeleccionado.firma ?? "");

            request
                .get(`Publicaciones_Detalle/Listado?folio=${eventoSeleccionado.folio}`)
                .then((detalle) => {
                    const dias = (detalle ?? []).map(d => {
                        const fecha = new Date(d.fecha_Envio);
                        return { day: fecha.getDate(), month: fecha.getMonth(), year: fecha.getFullYear(), consecutivo: d.consecutivo };
                    });
                    diasPub.hidratar(dias);
                })
                .catch(() => {});
        }
    }, [open]);

        const onLimpiar = () => {
        setTipoPublicacion("");
        setLinea("");
        setPrecioLista("");
        setPrecioEspecial("");
        setBeneficios("");
        setVigencias("");
        setRestricciones("");
        setEscenografia("");
        setImagen("");
        setHora("");
        setRedSocial([]);
        setFirma("");
        setOpenFirmas(false);
        diasPub.reiniciar();
        setOpenTipos(false);
        setArchivoImagen(null);
        setImagenBase64("");
        setCargar(true);
        setVista("formulario");
        setGenerandoImagen(false);
        setImagenGenerada(null);
        setFolioBorrador(null);

        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const onCerrar = () => {
        onLimpiar();
        onClose();
    };


    const MAX_BYTES = 5 * 1024 * 1024; // 5MB

    const comprimirImagen = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                img.onload = () => {
                    let width = img.width;
                    let height = img.height;
                    let calidad = 0.9;

                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    const intentarComprimir = () => {
                        canvas.width = width;
                        canvas.height = height;
                        ctx.clearRect(0, 0, width, height);
                        ctx.drawImage(img, 0, 0, width, height);

                        canvas.toBlob(
                            (blob) => {
                                if (!blob) return reject(new Error("No se pudo comprimir la imagen"));

                                if (blob.size <= MAX_BYTES || (calidad <= 0.3 && width <= 800)) {
                                    // Ya quedó por debajo de 5MB, o llegamos al límite razonable de compresión
                                    const nombre = file.name.replace(/\.[^/.]+$/, "") + ".jpg";
                                    const archivoComprimido = new File([blob], nombre, { type: "image/jpeg" });
                                    resolve(archivoComprimido);
                                } else {
                                    // Reducimos calidad primero, y si ya no ayuda, reducimos dimensiones
                                    if (calidad > 0.3) {
                                        calidad -= 0.1;
                                    } else {
                                        width = Math.round(width * 0.85);
                                        height = Math.round(height * 0.85);
                                    }
                                    intentarComprimir();
                                }
                            },
                            "image/jpeg",
                            calidad
                        );
                    };

                    intentarComprimir();
                };
                img.onerror = () => reject(new Error("No se pudo leer la imagen"));
                img.src = e.target.result;
            };
            reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
            reader.readAsDataURL(file);
        });
    };


    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const extensionesPermitidas = ["png", "jpg", "jpeg"];
        const mimePermitidos = ["image/png", "image/jpeg"];
        const extension = file.name.split(".").pop().toLowerCase();

        if (
            !extensionesPermitidas.includes(extension) ||
            !mimePermitidos.includes(file.type)
        ) {
            Swal.fire(
                "REDES SOCIALES",
                "Solo se permiten imágenes PNG, JPG o JPEG.",
                "warning"
            );

            fileInputRef.current.value = "";
            setArchivoImagen(null);
            setImagen("");
            setImagenBase64("");
            return;
        }

        let archivoFinal = file;

        if (file.size > MAX_BYTES) {
            try {
                archivoFinal = await comprimirImagen(file);
            } catch (error) {
                Swal.fire("REDES SOCIALES", "No se pudo comprimir la imagen", "error");
                fileInputRef.current.value = "";
                return;
            }
        }

        setArchivoImagen(archivoFinal);
        setImagen(archivoFinal.name);

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(",")[1];
            setImagenBase64(base64);
        };
        reader.readAsDataURL(archivoFinal);
    };

    const onGuardar = async () => {
        if (!tipoPublicacion) return Swal.fire("REDES SOCIALES", "Seleccione un tipo de publicación", "warning");
        if (!linea) return Swal.fire("REDES SOCIALES", "Ingrese la línea", "warning");
        if (["Liquidación", "Promoción"].includes(tipoPublicacion) && !precioEspecial) return Swal.fire("REDES SOCIALES", "Ingrese el precio especial", "warning");
        if (["Liquidación", "Promoción"].includes(tipoPublicacion) && !imagenBase64)
            return Swal.fire("REDES SOCIALES", "Debe cargar una imagen para publicaciones de tipo Liquidación o Promoción", "warning");
        if (diasPub.diasSeleccionados.length === 0) return Swal.fire("REDES SOCIALES", "Seleccione al menos un día de publicación", "warning");
        if (redSocial.length === 0) return Swal.fire("REDES SOCIALES", "Seleccione al menos una red social", "warning");
        if (!esCampaña && !esPromocion && !precioLista) return Swal.fire("REDES SOCIALES", "Ingrese el precio de lista", "warning");
        setGuardando(true);
        try {
            if (esEdicion) {
                await request.post("Encabezado/Editar", {
                    Folio: eventoSeleccionado.folio,
                    Linea: linea,
                    Tipo_Publicacion: tipoPublicacion,
                    Precio_Lista: (esCampaña || esPromocion) ? 0 : parseFloat(precioLista),
                    Precio_Especial: precioEspecial ? parseFloat(precioEspecial) : null,
                    Beneficios: beneficios,
                    Vigencias: vigencias,
                    Restricciones: restricciones,
                    Escenografia: escenografia,
                    Hora: hora || null,
                    Red_Social: redSocial.length > 0
                        ? redSocial.join(", ")
                        : null,
                    Firma: firma || null,
                    Imagen: imagen,
                    ImagenBase64: imagenBase64,
                    Cargar: cargar

                });

                const diasEliminar = diasPub.diasOriginales.filter(orig =>
                    !diasPub.diasSeleccionados.some(d => d.day === orig.day && d.month === orig.month && d.year === orig.year)
                );
                const diasAgregar = diasPub.diasSeleccionados.filter(sel =>
                    !diasPub.diasOriginales.some(d => d.day === sel.day && d.month === sel.month && d.year === sel.year)
                );

                for (const dia of diasEliminar) {
                    await request.post("Publicaciones_Detalle/Eliminar", {
                        Folio: eventoSeleccionado.folio,
                        folio: eventoSeleccionado.folio,
                        Consecutivo: dia.consecutivo,
                        consecutivo: dia.consecutivo
                    });
                }
                for (const dia of diasAgregar) {
                    const fecha = new Date(dia.year, dia.month, dia.day);
                    await request.post("Publicaciones_Detalle/Guardar", {
                        Folio: eventoSeleccionado.folio,
                        folio: eventoSeleccionado.folio,
                        Fecha_Envio: fecha.toISOString(),
                        fecha_Envio: fecha.toISOString(),
                        Estatus: "Pendiente",
                        estatus: "Pendiente"
                    });
                }

            } else if (editandoBorrador) {
                await request.post("Encabezado/Editar", {
                    Folio: folioBorrador,
                    Linea: linea,
                    Tipo_Publicacion: tipoPublicacion,
                    Precio_Lista: (esCampaña || esPromocion) ? 0 : parseFloat(precioLista),
                    Precio_Especial: precioEspecial ? parseFloat(precioEspecial) : null,
                    Beneficios: beneficios,
                    Vigencias: vigencias,
                    Restricciones: restricciones,
                    Escenografia: escenografia,
                    Hora: hora || null,
                    Red_Social: redSocial.length > 0
                        ? redSocial.join(", ")
                        : null,
                    Firma: firma || null,
                    Imagen: imagen,
                    ImagenBase64: imagenBase64,
                    Cargar: cargar
                });

                setGuardando(false);
                setVista("revision");
                solicitarGeneracion(folioBorrador, imagenGenerada?.fechaEnvio);
                return;
            } else {
                const formData = new FormData();

                formData.append("Folio", "0");
                formData.append("Linea", linea);
                formData.append("Tipo_Publicacion", tipoPublicacion);
                formData.append("Precio_Lista", (esCampaña || esPromocion) ? 0 : parseFloat(precioLista));
                if (precioEspecial) formData.append("Precio_Especial", parseFloat(precioEspecial));
                formData.append("Beneficios", beneficios);
                formData.append("Vigencias", vigencias);
                formData.append("Restricciones", restricciones);
                formData.append("Escenografia", escenografia);
                formData.append("Cargar", cargar ? "true" : "false");
                if (hora) formData.append("Hora", hora);
                if (redSocial.length > 0)
                    formData.append("Red_Social", redSocial.join(", "));
                if (firma) formData.append("Firma", firma);

                if (archivoImagen) {
                    formData.append("Archivo", archivoImagen);
                }

                const resultEnc = await request.postForm("Encabezado/Guardar", formData);
                const folio = resultEnc.folio || resultEnc.Folio;
                setFolioBorrador(folio);

                let fechaEnvioRepresentativa = null;
                for (const dia of diasPub.diasSeleccionados) {
                    const fecha = new Date(dia.year, dia.month, dia.day);
                    if (!fechaEnvioRepresentativa) fechaEnvioRepresentativa = fecha.toISOString();
                    await request.post("Publicaciones_Detalle/Guardar", {
                        Folio: folio,
                        folio: folio,
                        Fecha_Envio: fecha.toISOString(),
                        fecha_Envio: fecha.toISOString(),
                        Estatus: "Pendiente",
                        estatus: "Pendiente"
                    });
                }

                onActualizar();
                setGuardando(false);
                setVista("revision");
                solicitarGeneracion(folio, fechaEnvioRepresentativa);
                return;
            }

            await Swal.fire("REDES SOCIALES", "Editado correctamente", "success");
            onActualizar();
            onCerrar();
        } catch (error) {
            Swal.fire("REDES SOCIALES", JSON.stringify(error), "error");
        } finally {
            setGuardando(false);
        }
    };

    const solicitarGeneracion = async (folio, fechaEnvioFallback) => {
        setGenerandoImagen(true);
        setImagenGenerada(null);
        try {
            const resultado = await generarImagenRedes({ Folio: folio });
            setImagenGenerada({
                base64: resultado.ImagenGeneradaBase64,
                copy: resultado.CopyGenerado,
                folio,
                tipoPublicacion: resultado.Tipo_Publicacion || tipoPublicacion,
                fechaEnvio: resultado.Fecha_Envio || fechaEnvioFallback,
            });
        } catch (error) {
            Swal.fire("REDES SOCIALES", "No se pudo generar la imagen. Puedes reintentar.", "error");
        } finally {
            setGenerandoImagen(false);
        }
    };

    const onNoMeGusto = () => {
        if (!imagenGenerada) return;
        solicitarGeneracion(imagenGenerada.folio, imagenGenerada.fechaEnvio);
    };

    const onDescargar = () => {
        if (!imagenGenerada) return;
        descargarBase64(imagenGenerada.base64, `${imagenGenerada.folio}.jpg`);
    };

    const onMeGusto = async () => {
        if (!imagenGenerada) return;
        setGuardando(true);
        try {
            await confirmarImagenRedes({
                Folio: imagenGenerada.folio,
                ImagenGeneradaBase64: imagenGenerada.base64,
                CopyGenerado: imagenGenerada.copy,
            });
            await Swal.fire("REDES SOCIALES", "Publicación guardada y notificada correctamente", "success");
            onActualizar();
            onCerrar();
        } catch (error) {
            Swal.fire("REDES SOCIALES", "No se pudo guardar la aprobación. Puedes reintentar.", "error");
        } finally {
            setGuardando(false);
        }
    };

    const onEliminar = async () => {
        const confirm = await Swal.fire({
            title: "¿Eliminar publicación?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        });

        if (!confirm.isConfirmed) return;

        setGuardando(true);
        try {
            await request.post("Encabezado/Eliminar", eventoSeleccionado.folio);
            await Swal.fire("REDES SOCIALES", "Eliminado correctamente", "success");
            onActualizar();
            onCerrar();
        } catch (error) {
            Swal.fire("REDES SOCIALES", JSON.stringify(error), "error");
        } finally {
            setGuardando(false);
        }
    };

    if (!open) return null;


    return (
        <div className="rs-modal-overlay">
            <div className="rs-modal" onClick={e => e.stopPropagation()}>

                <div className="rs-modal__header">
                    <span className="rs-modal__title">
                        {vista === "revision"
                            ? "Revisa la imagen generada"
                            : esEdicion ? `Editar — ${eventoSeleccionado.folio}`
                            : editandoBorrador ? `Editar antes de regenerar — ${folioBorrador}`
                            : "Nueva Publicación"}
                    </span>
                    <button className="rs-modal__close" onClick={onCerrar} disabled={generandoImagen}>✕</button>
                </div>

                {vista === "revision" ? (
                    <>
                        <div className="rs-modal__body">
                            <div className="rs-field" style={{ textAlign: "center" }}>
                                {generandoImagen && (
                                    <div className="rs-loading">
                                        <div className="rs-loading__spinner" />
                                        <span>Generando imagen con IA, un momento...</span>
                                    </div>
                                )}

                                {!generandoImagen && imagenGenerada && (
                                    <>
                                        <img
                                            src={`data:image/jpeg;base64,${imagenGenerada.base64}`}
                                            alt="Imagen generada"
                                            style={{ width: "100%", borderRadius: "8px", maxHeight: "420px", objectFit: "contain" }}
                                        />
                                        <p className="rs-field__hint" style={{ marginTop: "10px" }}>
                                            ¿Te gusta el resultado? Si le das "Volver a generar" se genera de nuevo (no se guarda nada).
                                            Si le das "Publicar" se guarda y se manda el correo de evidencia.
                                        </p>
                                    </>
                                )}

                                {!generandoImagen && !imagenGenerada && (
                                    <p className="rs-field__hint">No se pudo generar la imagen.</p>
                                )}
                            </div>
                        </div>

                        <div className="rs-modal__footer" style={{ justifyContent: "space-between" }}>
                            <button
                                className="rs-btn rs-btn--ghost"
                                onClick={onDescargar}
                                disabled={guardando || generandoImagen || !imagenGenerada}
                            >
                                ⬇️ 
                            </button>

                            <button
                                className="rs-btn rs-btn--danger"
                                onClick={onNoMeGusto}
                                disabled={guardando || generandoImagen}
                                style={{ marginRight: 0 }}
                            >
                                👎 Volver a generar
                            </button>

                            <button
                                className="rs-btn rs-btn--ghost"
                                onClick={() => setVista("formulario")}
                                disabled={guardando || generandoImagen}
                            >
                                ✏️ Editar
                            </button>

                            <button
                                className="rs-btn rs-btn--primary"
                                onClick={onMeGusto}
                                disabled={guardando || generandoImagen || !imagenGenerada}
                            >
                                {guardando ? "Guardando..." : "👍 Guardar"}
                            </button>
                        </div>
                    </>
                ) : (
                <>
                <div className="rs-modal__body">

                    <div className="rs-field">
                        <label className="rs-field__label">Tipo de Publicación</label>
                        <div className={`rs-select ${openTipos ? "open" : ""}`}>
                            <button
                                className="rs-select__trigger"
                                onClick={() => !cargandoTipos && setOpenTipos(o => !o)}
                                disabled={cargandoTipos}
                            >
                                {cargandoTipos ? (
                                    <span className="rs-select__loading">
                                        <span className="rs-select__spinner" />
                                        Cargando tipos por favor espere...
                                    </span>
                                ) : (
                                    <span className={tipoPublicacion ? "" : "placeholder"}>{tipoPublicacion || "Seleccione un tipo"}</span>
                                )}
                                <span className="rs-select__arrow">▾</span>
                            </button>
                            {openTipos && !cargandoTipos && (
                                <div className="rs-select__dropdown">
                                    {listadoTipos.map((t, i) => (
                                        <div key={i} className={`rs-select__option ${tipoPublicacion === t ? "selected" : ""}`}
                                            onClick={() => { setTipoPublicacion(t); setOpenTipos(false); }}>
                                            {t}
                                        </div>
                                    ))}
                                    {listadoTipos.length === 0 && (
                                        <div className="rs-select__option">Sin tipos registrados</div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label">Imagen <span className="rs-field__hint">(Click para buscar archivo en tu equipo)</span></label>

                        {imagenBase64 && (
                            <img
                                src={`data:image/jpeg;base64,${imagenBase64}`}
                                alt="Imagen actual"
                                style={{ width: '100%', borderRadius: '8px', marginBottom: '8px', maxHeight: '200px', objectFit: 'contain' }}
                            />
                        )}

                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <input
                                className="rs-input"
                                type="text"
                                placeholder={esEdicion ? "Selecciona nueva imagen para reemplazar" : "nombre-imagen.jpg (Haz click aquí)"}
                                value={imagen}
                                onChange={e => setImagen(e.target.value)}
                                onClick={() => fileInputRef.current.click()}
                                style={{ paddingRight: '40px', cursor: 'pointer' }}
                                readOnly
                            />
                            <span
                                onClick={() => fileInputRef.current.click()}
                                style={{ position: 'absolute', right: '12px', cursor: 'pointer', fontSize: '16px', userSelect: 'none' }}
                            >
                                📁
                            </span>
                        </div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                            onChange={handleFileChange}
                        />
                    </div>

                    {!esCampaña && (
                        <div className="rs-field">
                            <label className="rs-field__label">Línea</label>
                            <div className={`rs-select ${openLineas ? "open" : ""}`}>
                                <button className="rs-select__trigger" onClick={() => setOpenLineas(o => !o)}>
                                    <span className={linea ? "" : "placeholder"}>{linea || "Seleccione una línea"}</span>
                                    <span className="rs-select__arrow">▾</span>
                                </button>
                                {openLineas && (
                                    <div className="rs-select__dropdown">
                                        {lineasFijas.map((l, i) => (
                                            <div key={i} className={`rs-select__option ${linea === l ? "selected" : ""}`}
                                                onClick={() => { setLinea(l); setOpenLineas(false); }}>
                                                {l}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {!esCampaña && (
                        <div className="rs-field-row">
                            {!esPromocion && (
                                <div className="rs-field">
                                    <label className="rs-field__label">Precio Lista</label>
                                    <input className="rs-input" type="number" placeholder="$0.00 ( Precio Viejo )" value={precioLista} onChange={e => setPrecioLista(e.target.value)} />
                                </div>
                            )}
                            <div className="rs-field">
                                <label className="rs-field__label">Precio Especial</label>
                                <input className="rs-input" type="number" placeholder="$0.00 ( Precio Nuevo )" value={precioEspecial} onChange={e => setPrecioEspecial(e.target.value)} />
                            </div>
                        </div>
                    )}

                    <div className="rs-field">
                        <label className="rs-field__label">{esCampaña ? "Mensaje Principal" : "Beneficios"}</label>
                        <textarea
                            className="rs-textarea"
                            rows={2}
                            placeholder={esCampaña
                                ? "Ejemplo:\nQuienes siembran esfuerzo cosechan grandes logros\n¡FELIZ Dia del Padre!"
                                : "Describe los beneficios..."}
                            value={beneficios}
                            onChange={e => setBeneficios(e.target.value)}
                        />
                    </div>


                        <div className="rs-field">
                        <label className="rs-field__label">
                            {esCampaña ? "Descripción para el CopyWriter" : "Vigencias"}
                        </label>

                        <input
                            className="rs-input"
                            type="text"
                            placeholder={
                                esCampaña
                                    ? "Describe el copy que debe generar la IA..."
                                    : "Ej: Del 1 al 31 de julio"
                            }
                            value={vigencias}
                            onChange={e => setVigencias(e.target.value)}
                        />
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label">{esCampaña ? "Personajes" : "Restricciones"}</label>
                        <textarea
                            className="rs-textarea"
                            rows={2}
                            placeholder={esCampaña
                                ? "Padre agricultor de 45 años con su hijo de 10 años observando un tractor"
                                : "Describe las restricciones..."}
                            value={restricciones}
                            onChange={e => setRestricciones(e.target.value)}
                        />
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label">Escenografía</label>
                        <input className="rs-input" type="text" placeholder="Describe la escenografía" value={escenografia} onChange={e => setEscenografia(e.target.value)} />
                    </div>

                        <div className="rs-field">
                            <label className="rs-field__label">Firma</label>
                            <div className={`rs-select ${openFirmas ? "open" : ""}`}>
                                <button className="rs-select__trigger" onClick={() => setOpenFirmas(o => !o)}>
                                    <span className={firma ? "" : "placeholder"}>{firma || "Seleccione una firma"}</span>
                                    <span className="rs-select__arrow">▾</span>
                                </button>
                                {openFirmas && (
                                    <div className="rs-select__dropdown">
                                        {firmasFijas.map((f, i) => (
                                            <div key={i} className={`rs-select__option ${firma === f ? "selected" : ""}`}
                                                onClick={() => { setFirma(f); setOpenFirmas(false); }}>
                                                {f}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                    <div className="rs-field-row">
                        <div className="rs-field">
                            <label className="rs-field__label">Hora de publicación</label>
                            <input
                                className="rs-input"
                                type="time"
                                value={hora}
                                onChange={e => setHora(e.target.value)}
                            />
                        </div>
                        <div className="rs-field">
                            <label className="rs-field__label">Red Social</label>

                            <div style={{ display: "flex", gap: "20px", marginTop: "8px" }}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={redSocial.includes("Facebook")}
                                        onChange={() => toggleRedSocial("Facebook")}
                                    />
                                    Facebook
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={redSocial.includes("Instagram")}
                                        onChange={() => toggleRedSocial("Instagram")}
                                    />
                                    Instagram
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={redSocial.includes("LinkedIn")}
                                        onChange={() => toggleRedSocial("LinkedIn")}
                                    />
                                    LinkedIn
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label">
                            Días de publicación{" "}
                            <span className="rs-field__hint">
                                {editandoBorrador ? "(ya confirmados, no se modifican aquí)" : "(selecciona o deselecciona días)"}
                            </span>
                        </label>

                        <div style={editandoBorrador ? { pointerEvents: "none", opacity: 0.6 } : undefined}>
                            <RSMiniCalendario dias={diasPub} />
                        </div>
                    </div>

                </div>

                <div className="rs-modal__footer">
                    {esEdicion && (
                        <button className="rs-btn rs-btn--danger" onClick={onEliminar} disabled={guardando}>
                            Eliminar
                        </button>
                    )}


                        {esEdicion && (
                        <button
                            className={`rs-btn ${cargar ? "rs-btn--warning" : "rs-btn--blue"}`}
                            onClick={() => setCargar(prev => !prev)}
                            disabled={guardando}
                            type="button"
                        >
                            {cargar ? "No cargar" : "✓ Cargar"}
                        </button>
                    )}


                    <button
                        className="rs-btn rs-btn--ghost"
                        onClick={editandoBorrador ? () => setVista("revision") : onCerrar}
                        disabled={guardando}
                    >
                        {editandoBorrador ? "Volver" : "Cancelar"}
                    </button>
                    <button className="rs-btn rs-btn--primary" onClick={onGuardar} disabled={guardando}>
                        {guardando ? "Guardando..." : esEdicion ? "Guardar cambios" : editandoBorrador ? "Guardar y regenerar" : "Guardar"}
                    </button>
                </div>
                </>
                )}

            </div>
        </div>
    );
};

export default RSAñadirModal;